import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-privacypolicy',
  templateUrl: './privacypolicy.component.html',
  styleUrls: ['./privacypolicy.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PrivacypolicyComponent implements OnInit {
  htmlContent: SafeHtml;
  loading = true;

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.http.get('assets/html/iDREAMSTermsandConditions.html', { responseType: 'text' })
      .subscribe(html => {
        const fullHtml = this.processHtml(html);
        this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(fullHtml);
        this.loading = false;
      });
  }

  private processHtml(html: string): string {
    const bodyContent = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);

    const styleTagsMatches = html.match(/<style[^>]*>[\s\S]*?<\/style>/gi) || [];
    const styleTags = styleTagsMatches.join('\n');

    if (bodyContent && bodyContent[1]) {
      return `
        ${styleTags}
        <div class="pdf2html-container">
          ${bodyContent[1]}
        </div>
      `;
    }

    return html;
  }
}
